/**
 * Created by Denis Kuzin on 04 april 2023
 */

QuestsConfig.collections = {

};